<template>
  <div class="down">
    <div class="downloadbox">
        <img src="../assets/account/bg_HAI.png"/>
        <div class="center">
            <a class="download-btn" href="https://play.google.com/store/apps/details?id=com.haiwen.reader"><img src="../assets/account/btn_android.png"/></a>
            <a class="download-btn" href="https://apps.apple.com/tw/app/%E5%97%A8%E6%96%87%E5%B0%8F%E8%AA%AA/id1485535288"><img src="../assets/account/btn_iphone.png"/></a>
        </div>
    </div>
  </div>
</template>

<script>
    import "utils/lib/rem";
export default {};
</script>

<style lang="stylus" scoped>
.down
    /*min-width  1400px*/
.downloadbox
    position relative
    img
        width 100%
    .center
        position absolute
        top 9rem //664px
        left 4.2rem
        .download-btn
            display block
            width 2.34rem
            height 0.77rem
            float left
        .download-btn img
            width 2.34rem
            height 0.77rem
        .download-btn:nth-child(1)
            margin-right 26px
</style>
